import React, { Component, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import PricingCards from "../PricingCards";
import NxaFAQMeetingPage from "../NxaFAQMeetingPage";
import CTAButtons from "../ReuasbleComponets/CTAButtons";
export const VideoAutoPlay = () => {
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      videoRef.current.play();
    } else {
      if (videoRef.current.play) {
        videoRef.current.pause();
      }
    }
  }, [isVisible]);

  return (
    <VisibilitySensor onChange={(isVisible) => setIsVisible(isVisible)}>
      <video width="120%" height="100%" controls muted loop ref={videoRef}>
        <source
          src="./../assets/videos/Nxatel_Meet_Smarter.mp4"
          type="video/mp4"
        />
      </video>
    </VisibilitySensor>
  );
};

class Meet extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <>
        <div className="Meet-outer">
          {/* Banner Main image */}
          <section className="meet-hero">
            <h1>NxaMeets: The Secure & Smart Virtual Meeting Solution</h1>
            <p>The easiest and secured way to host meetings​</p>
            <div className="meet-button">
              <CTAButtons />
            </div>
            <div className="meet-image">
              <img
                className="meet"
                src="./../assets/images/new_meet_page/meetmain.webp"
                alt="Answering Messages"
                loading="lazy"
              />
            </div>
          </section>

          {/* Why Choose NxaTel */}
          <section className="why-choose">
            <h2 className="title">Why Choose Nxatel?</h2>
            <div className="grid-container">
              {/* Card 1 */}
              <div className="grid-item">
                <div className="card-circle">
                  <img
                    src="./../assets/images/wn-1.svg"
                    alt="Instant Set-Up"
                    className="icon"
                  />
                </div>
                <h3 className="feature-title">Instant & Secure Meetings</h3>
                <p className="feature-description">
                  No downloads required – join instantly via browser. End-to-end
                  encryption ensures private conversations. Secure meeting
                  lobbies prevent unauthorised access.
                </p>
              </div>

              {/* Card 2 */}
              <div className="grid-item">
                <div className="card-circle">
                  <img
                    src="./../assets/images/new_meet_page/calender.svg"
                    alt="Scattered Tools"
                    className="icon"
                  />
                </div>
                <h3 className="feature-title">
                  Smart Scheduling & Integration
                </h3>
                <p className="feature-description">
                  Sync with Google & Outlook calendars for seamless
                  scheduling.Multiple email reminders to reduce no-shows.Meeting
                  widget embed for quick access.
                </p>
              </div>

              {/* Card 3 */}
              <div className="grid-item">
                <div className="card-circle">
                  <img
                    src="./../assets/images/new_meet_page/Collaboration.svg"
                    alt="Missed Opportunities"
                    className="icon"
                  />
                </div>
                <h3 className="feature-title">Collaboration Beyond Video</h3>
                <p className="feature-description">
                  Breakout rooms for group discussions. File sharing & chat
                  messaging with internal and external guests. Whiteboarding &
                  co-annotation for real-time brainstorming.
                </p>
              </div>
            </div>
          </section>

          {/* Build Teams */}
          <div className="work-together">
            <div className="work-together__container">
              <h2 className="work-together__title">Built for your teams</h2>
              <p className="work-together__subtitle">
                Stay connected and productive with everything in one place—no
                <br /> more juggling multiple apps.
              </p>

              <div className="work-together__cards">
                {/* Card 1 */}
                <div className="work-together__card">
                  <div className="work-together__card-header">For Startups</div>
                  <div className="work-together__card-image">
                    <img
                      src="./../assets/images/new_meet_page/mobile.webp"
                      alt="Mobile App"
                      loading="lazy"
                    />
                  </div>
                  <Link to="/signup" className="work-together__card-link">
                    <span className="work-together__card-link-text">
                      Download and
                      <br /> Try for Free
                    </span>
                    <img
                      src="./../assets/images/right-arrow-dwn.svg"
                      alt="Right Arrow"
                      className="work-together__card-link-icon"
                    />
                  </Link>
                </div>

                {/* Card 2 */}
                <div className="work-together__card">
                  <div className="work-together__card-header">
                    For Teams &amp; Managers
                  </div>
                  <div className="work-together__card-image">
                    <img
                      src="./../assets/images/new_meet_page/meeting.gif"
                      alt="Laptop"
                      loading="lazy"
                    />
                  </div>
                  <Link to="/demo" className="work-together__card-link">
                    <span className="work-together__card-link-text">
                      Get your Demo
                      <br /> See Nxatel in action
                    </span>
                    <img
                      src="./../assets/images/right-arrow-dwn.svg"
                      alt="Right Arrow"
                      loading="lazy"
                      className="work-together__card-link-icon"
                    />
                  </Link>
                </div>

                {/* Card 3 */}
                <div className="work-together__card">
                  <div className="work-together__card-header">
                    For Meeting Rooms
                  </div>
                  <div className="work-together__card-image">
                    <img
                      src="./../assets/images/new_meet_page/meetdevice.webp"
                      alt="Device"
                      loading="lazy"
                      width={270}
                    />
                  </div>
                  <Link to="#" className="work-together__card-link">
                    <span className="work-together__card-link-text">
                      Explore our Devices
                    </span>
                    <img
                      src="./../assets/images/right-arrow-dwn.svg"
                      alt="Right Arrow"
                      loading="lazy"
                      className="work-together__card-link-icon"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* One platform. Host Beautiful Meetings with built-in team messaging.​ */}
          <div className="backgroundwhite">
            <section className="one-platform">
              <h1>
                One platform. Host Beautiful Meetings with built-in team
                messaging.​
              </h1>
              <p>Enable your teams to work anywhere they want.​​</p>
              <div className="one-platform-container">
                <div className="one-platform-video">
                  <div className="one-platform-video-box">
                    <VideoAutoPlay />
                  </div>
                </div>
                <div className="one-platform-content">
                  <h2>Organize Virtual meetings from any device</h2>
                  <p>
                    With the NxaMeets by Nxatel solution, easily meet with your
                    colleagues and clients in real time. Your teams can launch
                    video calls from their computer, smartphone or tablet. ​
                  </p>
                  <h2>Schedule and Connect your Calendar.​​</h2>
                  <p>
                    Name your meeting, invite participants, and set a date — all
                    on one screen. Then with one click, you can start your
                    call.​
                  </p>
                  <a href="/signup">
                    <button className="schedule-button">
                      Try it Schedule your first meeting{" "}
                      <span className="arrow">▶</span>
                    </button>
                  </a>
                </div>
              </div>
              <p className="product-video-cta">
                Interested in seeing these features in action? Check out our
                NxaMeets product video{" "}
                <a href="#" className="watch-video">
                  Watch Video <i class="fas fa-play ml-2"></i>
                </a>
              </p>
            </section>
          </div>
          {/* Secure, Smart & Seamless */}
          <section className="smart-secure-seamless">
            <h2 className="smart-secure-seamless__title">
              Secure, Smart, & Seamless Virtual Meetings
            </h2>
            <p className="smart-secure-seamless__subheading ">
              Host, Collaborate, and Connect Instantly from Any Device
            </p>
            <div className="smart-secure-seamless__grid">
              {/* Card 1 */}
              <div className="smart-secure-seamless__item">
                <div className="smart-secure-seamless__icon-container">
                  <img
                    src="./../assets/images/bi_shield-lock-fill.png"
                    alt="Instant Set-Up"
                    className="smart-secure-seamless__icon"
                  />
                </div>
                <h3 className="smart-secure-seamless__feature-title">
                  Secure & Encrypted
                </h3>
                <p className="smart-secure-seamless__feature-description">
                  End-to-end encryption, password protection, secure lobbies,
                  and meeting lock.
                </p>
              </div>

              {/* Card 2 */}
              <div className="smart-secure-seamless__item">
                <div className="smart-secure-seamless__icon-container">
                  <img
                    src="./../assets/images/new_meet_page/calender.svg"
                    alt="Scattered Tools"
                    className="smart-secure-seamless__icon"
                  />
                </div>
                <h3 className="smart-secure-seamless__feature-title">
                  Smart Scheduling
                </h3>
                <p className="smart-secure-seamless__feature-description">
                  Google & Outlook calendar integration, instant browser access,
                  and multiple email reminders.
                </p>
              </div>

              {/* Card 3 */}
              <div className="smart-secure-seamless__item">
                <div className="smart-secure-seamless__icon-container">
                  <img
                    src="./../assets/images/bi_record-circle.png"
                    alt="Missed Opportunities"
                    className="smart-secure-seamless__icon"
                  />
                </div>
                <h3 className="smart-secure-seamless__feature-title">
                  Securely record
                </h3>
                <p className="smart-secure-seamless__feature-description">
                  Your meetings to the cloud, and store unlimited recordings to
                  your NxaBox storage Account​
                </p>
              </div>

              {/* Card 4 */}
              <div className="smart-secure-seamless__item">
                <div className="smart-secure-seamless__icon-container">
                  <img
                    src="./../assets/images/new_meet_page/Frame.svg"
                    alt="24/7 Support"
                    className="smart-secure-seamless__icon"
                  />
                </div>
                <h3 className="smart-secure-seamless__feature-title">
                  HD Video & Audio
                </h3>
                <p className="smart-secure-seamless__feature-description">
                  High-definition video, noise suppression, and custom virtual
                  backgrounds for professional meetings.
                </p>
              </div>
            </div>
          </section>

          {/* Plans */}
          <section>
            <div
              style={{
                fontSize: "60px",
                fontWeight: "500",
                textAlign: "center",
                padding: "40px 0px",
              }}
            >
              Flexible Plans for Every Business
            </div>
            <div
              style={{
                fontSize: "25px",
                fontWeight: "300",
                textAlign: "center",
                marginBottom: "50px",
              }}
            >
              Find the perfect plan that fits your needs{" "}
              <span className="highlighted-text" style={{ size: "15px" }}>
                —no hidden fees
              </span>
              , no long-term contracts.
            </div>
            <PricingCards />
          </section>

          {/* FAQ */}
          <NxaFAQMeetingPage />
          {/* Try NxaMeets Free */}
          <section className="meet-free">
            <div className="meet-free-image">
              <img
                className="meet-free-img"
                src="./../assets/images/new_meet_page/meetfree.webp"
                alt="Meeting on Laptop"
                loading="lazy"
              />
            </div>
            <div className="meet-free-content">
              <h1>Try NxaMeets for Free!</h1>
              <ul>
                <li>No long-term contracts – upgrade or cancel anytime.</li>
                <li>
                  {" "}
                  Secure, fast, and reliable video meetings on any device.
                </li>
              </ul>
              <div className="meet-button">
                <CTAButtons />
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default Meet;
